import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actionCreators from '../BookingForm/actions';
import bowser from 'bowser';
import {Map} from 'immutable';

export class BookingInput extends React.Component {

    constructor(props) {
      super();
        this.state = {
          ...props,
            defaultRegionName: '3 Valleys',
            focused: false,
            value: props.name === 'regions' ? '3 Valleys' : 'Any',
            anyValue: props.name === 'regions' ? '3 Valleys' : 'Any', 
            dirty: false,
            userAgent: bowser,
            selectedIndex: -1,
            readyToBlur: false,
            inputRef: React.createRef(),
            listRef: React.createRef()
        };
    }

    handleIeBlur(e) {
        if (!this.state.focused) {
            return;
        }
        let element = e.target;
        let shouldBlur = true;
        do {
            if (element.getAttribute('data-booking-input-name') === this.props.name) {
                shouldBlur = false;
            }
            element = element.parentElement;
        } while (element);
        this.setState({focused: !shouldBlur});
    }

    findMatch() {
        this.setState({focused: false});
        if (this.props.textFieldValue === '') {
          this.props.updateTextField(this.props.name, this.state.anyValue);
        }
        //search through list of entries to find nearest match
        let foundBeginningMatch = false;
        let foundAnyMatch = false;
        const thisValueLower = this.props.textFieldValue.toLowerCase();
        this.props.entries.valueSeq().forEach(value => {

            
            const nameLower = value.get('name').toLowerCase();
            if (thisValueLower === nameLower) {
              foundBeginningMatch = true;
              foundAnyMatch = true;
              this.props.updateTextField(this.props.name, value.get('name'));
              return;
            } else if (nameLower.indexOf(thisValueLower) === 0) {
              foundBeginningMatch = true;
              foundAnyMatch = true;
              this.props.updateTextField(this.props.name, value.get('name'));
            }
        });

        if (!foundBeginningMatch) {
            this.props.entries.valueSeq().forEach(value => {
                const nameLower = value.get('name').toLowerCase();

                if (thisValueLower === nameLower) {
                    foundAnyMatch = true;
                    return;
                }

                if (nameLower.indexOf(thisValueLower) !== -1 && thisValueLower !== 'any') {
                    foundAnyMatch = true;
                    this.props.updateTextField(this.props.name, value.get('name'));
                }
            });
        }

        if (!foundAnyMatch && !foundBeginningMatch) {
          this.props.updateTextField(this.props.name, this.state.anyValue);
        }
    }

    handleBlur(e) {
        if (this.state.userAgent.msie || this.state.userAgent.msedge) {
            this.handleIeBlur(e);
            return;
        }
        setTimeout(() => {
            this.findMatch();
        }, 150);
    }

    keyListener(e) {
        const keyCode = e.keyCode;
        const entries = this.props.entries;
        let selectedIndex = this.state.selectedIndex;
        e.persist();

        if (keyCode !== 40 && keyCode !== 38 && keyCode !== 13) {
            return;
        }
        switch (keyCode) {
            case 40:
                //down has been pressed
                selectedIndex = Math.min(entries.count() - 1, selectedIndex + 1);
                break;
            case 38:
                selectedIndex = Math.max(-1, selectedIndex - 1);
                break;
            default:
                //return was pressed
                e.preventDefault();
                const val = this.props.textFieldValue;
                if(val === '') {
                    this.props.updateTextField(this.props.name, this.props.entries.toIndexedSeq().get(selectedIndex).get('name'));
                    this.setState({focused: false});
                    return;
                }
                setTimeout(() => {
                    this.findMatch();
                }, 150);
                this.setState({focused: false});
        }

        this.setState({
            selectedIndex
        });

        setTimeout(() => {
            const entryList = this.state.listRef.current;
            let hightlightedItem = entryList.getElementsByClassName('booking-input__item --selected');

            if (selectedIndex === -1) {
                entryList.scrollTop = 0;
            }

            if (hightlightedItem.length > 0) {
                hightlightedItem = hightlightedItem[0];
                const heightToScroll = hightlightedItem.offsetHeight;

                if (hightlightedItem.offsetTop >= (entryList.scrollTop + entryList.offsetHeight) - heightToScroll) {
                    entryList.scrollTop += heightToScroll;
                } else if (hightlightedItem.offsetTop <= entryList.scrollTop) {
                    entryList.scrollTop -= heightToScroll;
                }
            }
        }, 90);
    }

    handleFocus() {
        if (this.state.userAgent.msie || this.state.userAgent.msedge) {
            document.addEventListener('click', this.handleIeBlur.bind(this));
        }
        this.setState({focused: true, value: ''});
        this.props.updateTextField(this.props.name, '');
    }

    render() {
        const labelName = this.props.name.slice(1).charAt(this.props.length - 1) === 's' ? this.props.name.slice(1, this.props.name.length - 1) : this.props.name.slice(1);
        return (
            <div className={'booking-input'} data-booking-input-name={this.props.name}>
                <label
                    className={'booking-input__label'}
                    htmlFor={`id_${this.props.name}`}>{this.props.name.charAt(0).toUpperCase() + labelName}</label>
                <div className={'booking-input__input-container'}>
                    <input id={`id_${this.props.name}`}
                           autoComplete={'off'}
                           ref={this.state.inputRef}
                           className={'input booking-input__input'}
                           onBlur={this.handleBlur.bind(this)}
                           onFocus={this.handleFocus.bind(this)}
                           onChange={e => {
                               this.setState({focused: true, selectedIndex: -1});
                               this.props.updateTextField(this.props.name, e.target.value, true);
                           }}
                           onKeyDown={this.keyListener.bind(this)}
                           name={this.props.name}
                           type={'text'}
                           value={this.props.textFieldValue}/>


                    <ul style={{display: (this.state.focused ? 'block' : 'none')}} ref={this.state.listRef}
                        className={'booking-input__list'}>
                        <li onClick={() => {
                            this.setState({focused: false});
                            this.props.updateTextField(this.props.name, '');
                }}
                        disabled
                  className={'booking-input__item'}>{this.props.name === 'regions' ? this.state.defaultRegionName : this.state.anyValue }</li>
                {this.props.entries.toIndexedSeq().map((value, number) => {
                            const thisValueLower = this.props.textFieldValue.toLowerCase();
                  const nameLower = value.get('name').toLowerCase();
                            if (thisValueLower !== '' && nameLower.indexOf(thisValueLower) === -1) {
                                return null;
                            }
                            if (nameLower === this.state.defaultRegionName.toLowerCase()) {
                                return null;
                            }

                            return <li onClick={() => {
                                this.setState({focused: false});
                                this.props.updateTextField(this.props.name, value.get('name'));
                            }}
                                       className={`booking-input__item ${(number === this.state.selectedIndex ? ' --selected' : '')}`}
                                       key={value.get('name')}>{value.get('name')}</li>;
                        })}
                    </ul>

                </div>

            </div>
        );
    }
}

BookingInput.propTypes = {
    name: PropTypes.string.isRequired
};

export default connect((stateMap, ownProps) => {
    const state = stateMap.get('bookingForm', Map({}));
    const textFieldValue = state.getIn(['inputFields', ownProps.name, 'value'], '');

    return {
        entries: ownProps.entries.sort((a, b) => (a.get('name').charCodeAt(0) - b.get('name').charCodeAt(0))),
        name: ownProps.name,
        textFieldValue,
        availproCode: state.getIn(['inputFields', ownProps.name, 'availproCode'], 0),
        diamondCode: state.getIn(['inputFields', ownProps.name, 'diamondCode'], 0)
    };
}, actionCreators)(BookingInput);
